import { memo, } from 'react';
import { CardContent, TextField, Typography, Grid, Box, Button, InputLabel, Select, MenuItem, FormControl, FormHelperText } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTMutation } from '../../../../../utils/useTMutation';
import showToast from '../../../../../components/Hot-Toast/showToast';

import { nextStep, update } from '../../../../../slice/multiStepSlice';
export const jobRoleSchema = z.object({
    DOCUMENT_NAME: z.string().min(1, { message: "Document Name is required" }),
    REQUIREMENT: z.string().min(1, { message: "Requirement is required" }),

});


const AddOnBoardingDocuments = ({ data }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { values } = useSelector((state) => state?.multiStep)
    const { userDetails } = useSelector(state => state.user);
    const { ID } = useParams();

    console.log("valueweferfes", ID)




    const {
        register,
        setValue,
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(jobRoleSchema),
        defaultValues: { DOCUMENT_NAME: values.DOCUMENT_NAME || '', REQUIREMENT: values.REQUIREMENT || '' },
    });

    const { mutateAsync } = useTMutation("/addOnBoardingDocument", "post", (response) => {
        if (response.STATUS) {
            return response;
        }
    });
    console.log("values?.ID", values?.ID);
    


    // const submitAddDocument = async (data) => {
    //     const formData = new FormData();
    //     formData.append("DOCUMENT_NAME", data.DOCUMENT_NAME);
    //     formData.append("REQUIREMENT", data.REQUIREMENT);    
    //     try {
    //         const response = await mutateAsync(formData);
    //         console.log("sssss", response);
    
    //         if (response.STATUS) {
    //             dispatch(update({ key: 'DOCUMENT_DATA', value: response.OUTPUT }));
    //             dispatch(nextStep());
    //         } else if (response.MESSAGE === "Document name is already exist.") {
    //             showToast("error", "Document name is already exist.", 3000);
    //         } else {
    //             showToast("error", data.MESSAGE, 3000);
    //         }
    //     } catch (error) {
    //         console.error("Add Request failed:", error);
    //         showToast("error", "Something went wrong, Please try again", 3000);
    //     }
    // };

    const submitAddDocument = async (formValues) => {
  const formData = new FormData();
  formData.append("DOCUMENT_NAME", formValues.DOCUMENT_NAME);
  formData.append("REQUIREMENT", formValues.REQUIREMENT);

  // ✅ Add this line to support update when editing
  if (values?.ID) {
    formData.append("ID", values?.ID);
  }

  try {
    const response = await mutateAsync(formData);
    console.log("sssss", response);

    if (response.STATUS) {
      dispatch(update({ key: 'DOCUMENT_DATA', value: response.OUTPUT }));
      dispatch(nextStep());
    } else if (response.MESSAGE === "Document name is already exist.") {
      showToast("error", "Document name is already exist.", 3000);
    } else {
      showToast("error", response.MESSAGE, 3000);
    }
  } catch (error) {
    console.error("Add Request failed:", error);
    showToast("error", "Something went wrong, Please try again", 3000);
  }
};


    return (
        <>
       
            <Grid lg={12} >
          
                 <CardContent className='gridcardcontent gridtextdata'>
                    <Typography variant="h2" component="div" fontWeight="bold" style={{ marginTop: -4 }}>
                        Add New Document
                    </Typography>
                    
                    <form onSubmit={handleSubmit(submitAddDocument)}>
                           
                        
                            <TextField
                                label="Document Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                className='document_name'
                                autoFocus
                                // InputProps={{ style: { height: '50px' } }}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: 1.94
                                    },
                                    '& .MuiFormHelperText-root': {
                                        marginLeft: 0,
                                        marginTop: '4px',
                                    },
                                }}
                                {...register("DOCUMENT_NAME")}
                                error={!!errors.DOCUMENT_NAME}
                                helperText={errors.DOCUMENT_NAME?.message}
                            />





                            <FormControl fullWidth sx={{ marginTop: 3 }} error={!!errors.REQUIREMENT}>
                                <InputLabel id="requirement-select-label">Requirement</InputLabel>
                                <Controller
                                    name="REQUIREMENT"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            // autoFocus
                                            labelId="requirement-select-label"
                                            className='document_name'
                                            // id="requirement-select"
                                            label="Requirement"
                                            {...field}
                                            error={!!errors.REQUIREMENT}
                                        >
                                            <MenuItem value="mandatory">Mandatory</MenuItem>
                                            <MenuItem value="optional">Optional</MenuItem>
                                        </Select>
                                    )}
                                />
                                {errors.REQUIREMENT && <FormHelperText>{errors.REQUIREMENT?.message}</FormHelperText>}
                            </FormControl>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2.5 }}>
                                <Button
                                    className='gradientAdminThemeColor'
                                    // variant="contained" sx={{ backgroundColor: '#6ebe44' }} 
                                    type='submit'>
                                    Next
                                </Button>
                            </Box>
                       
                    </form>
                 </CardContent> 
            </Grid>

        </>
    );
};

export default memo(AddOnBoardingDocuments);

